import clsx from 'clsx'
import React, {useContext} from 'react'
import {useHistory} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Button from '@mui/material/Button'
import AddIcon from '@mui/icons-material/Add'

import create from 'helpers/command'

import Box from '@mui/material/Box'
import {TeacherContext} from 'teacher/context'


const useStyles = makeStyles(createExamnStyles)

export default function CreateExamn() {

  const classes = useStyles()
  const context = useContext(TeacherContext)
  const history = useHistory()
  const {translate, quizQuestionTypes, updateState, link, linkQuery, updateStae} = context


  const handleClick = (event) => {
    updateState({quizQuestionBankCartEl: {$set: null}, quizDialogs: {'create-assessment': {$set: true}}})
  }

  return (
    <Box className={classes.root}>
      <Button className={classes.button} startIcon={<AddIcon />} onClick={handleClick}>{translate('create')}</Button> 
    </Box>
  )
}

function createExamnStyles(theme) {
  return {
    root: {
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
      justifyContent: 'center',
    },
    button: {
      padding: '4px 10px',
      backgroundColor: '#62c874',
      color: '#fff',
      textTransform: 'capitalize',
      '& .MuiButton-startIcon': {
        marginRight: 3
      },
      '&:hover': {
        backgroundColor: '#29652c'
      }
    }
  }
}

